<template>
  <div class="app c-app flex-row align-items-center">
    <div class="cover"></div>
    <!-- class="login" -->
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="9">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>

                <spinner-ttt :show="loading"></spinner-ttt>

                <div style="width: 100%;padding-bottom: 50px;">
                  <div class="col-md-12" style="align-content: center;text-align: center;">
                    <!-- <img class="navbar-brand-full logo" src="logo/logo.png" height="70" alt="MIMOTO - Área privada clientes MimoTo"> -->
                    <img class="navbar-brand-minimized" src="logo/logo.png"  height="50" alt="MIMOTO - Área privada clientes MimoTo">

                    <div class="new-account">
                      <!-- <router-link to="/register" class="new-account"> -->
                      <!-- <router-link :to="{ path: '/auth/register', params: { plan_id: currentNewPlanId }}" class="new-account"> -->

                          <!-- <router-link to="/clientes" class="new-account"> -->
                      <p class="mt-4">¿No tienes cuenta?</p>

                      <router-link to="/clientes/personal">
                          <CButton color="primary" class="px-4 btn-login">Créala ahora y hazte socio</CButton>
                      </router-link>

                    </div>
                  </div>
                </div>

                <CForm class="form-mimoto">

                  <h1>Iniciar Sesión</h1>
                  <p class="text-muted">Accede a tu cuenta</p>
                  <CInput
                    id="email" name="email"
                    placeholder="Email"
                    autocomplete="email"
                    v-model="email"
                    v-validate="'required|email'"
                    data-vv-validate-on="change"
                    v-bind:invalid-feedback="errors.first('email')"
                    :addInputClasses="{ 'is-invalid': errors.first('email') }"
                    v-on:keypress.enter="login"
                  >
                    <template #prepend-content><CIcon name="cil-user"/></template>
                  </CInput>

                  <CInput
                    id="password" name="password"
                    placeholder="Contraseña"
                    type="password"
                    autocomplete="curent-password"
                    v-model="password"
                    v-validate="'required|min:6'"
                    data-vv-validate-on="change"
                    v-bind:invalid-feedback="errors.first('password')"
                    :addInputClasses="{ 'is-invalid': errors.first('password') }"
                    required
                    v-on:keypress.enter="login"
                  >
                  <!-- v-validate="'required|formatPassword'" -->
                    <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                  </CInput>

                  <!-- <ul>
                    <li v-for="(error, index) in errors.collect('password')" :value="error" :key="index">{{ error }}</li>
                  </ul> -->

                  <p class="invalid-feedback d-block mt-0 mb-3">
                    {{ message }}
                  </p>

                  <CRow>
                    <CCol col="4" class="text-left">
                      <CButton color="primary" class="px-4 btn-login" @click="login">Entrar</CButton>
                    </CCol>

                    <CCol col="8" class="text-right">

                      <router-link to="/restablecer-contrasenya">
                        <CButton color="link" class="px-0">¿Has olvidado tu contraseña?</CButton>
                      </router-link>

                      <!-- <CButton color="link" class="px-0">Has olvidado tu contraseña?</CButton> -->
                      <!-- <CButton color="link" class="d-lg-none">Register now!</CButton> -->
                    </CCol>

                  </CRow>
                </CForm>

              </CCardBody>


            </CCard>


            <!-- <CCard
              color="primary"
              text-color="white"
              class="text-center py-5 d-md-down-none"
              body-wrapper
            >
              <CCardBody>
                <h2>Sign up</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                <CButton
                  color="light"
                  variant="outline"
                  size="lg"
                >
                  Register Now!
                </CButton>
              </CCardBody>
            </CCard> -->


          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>

    <toast ref="toast"></toast>
  </div>

</template>

<script>

import validator from '@/validator';
import Toast from '@/app/shared/components/Toast';
import SpinnerTtt from '@/app/shared/components/SpinnerTtt';

import { validationMixin } from "vuelidate";
import { required, minLength, email, sameAs, helpers } from "vuelidate/lib/validators"
// import {formatDateTimeCustom, formatDateTimeCustomTest} from '@/app/shared/utils/utils';

import { login } from '../shared/services';
import { MIMOTO_MAIL_CLIENTS } from '@/config';

export default {
  name: 'Login',
  components: {
    Toast,
    SpinnerTtt
  },
  data() {
    return {
      email: null,
      password: null,
      message: null,
      loading: false,
      dirty: false,
      submitted: false,
      currentNewPlanId: null, // TODO: id plan seleccionado en formulario contratación corporativa
      MIMOTO_MAIL_CLIENTS: MIMOTO_MAIL_CLIENTS,
      // start_datetime: "2022-05-24T10:04:10.000000Z", // "2022-12-23 15:00:00", //
      // formatDateTimeCustomTest: formatDateTimeCustomTest,
      // formatDateTimeCustom: formatDateTimeCustom
    }
  },
  mounted() {
    // if (this.$route.query && this.$route.query.expired) {
    //   this.$refs.toast.showToast('La sesión ha caducado. Por favor, inicie sesión de nuevo.', null, 'error', '5000');
    // }

    // console.log(this.$fields.$myScope.email.dirty);

  },
  created() {
    document.title = 'mimoTo - Restablecer contraseña'
  },
  computed: {
    isFormDirty() {
      if (this.$veeFields){
        return Object.keys(this.$veeFields).some(key => this.$veeFields[key].dirty);
      } else {
        false
      }
    }
  },
  methods: {
    isFormDirtyMethod() {
      if (!this.veeFields['$scopeName']) {
          return false;
      }
      return Object.keys(this.veeFields['$scopeName']).some(key => this.veeFields['$scopeName'][key].dirty);
    },
    // checkIfValid (fieldName) {
    //   const field = this.$v.form[fieldName]
    //   if (!field.$dirty) {
    //     return null
    //   }
    //   return !(field.$invalid || field.$model === '')
    // },
    login() {

      // console.log(this.veeFields['$scopePassword']);
      // this.$refs.toast.showToast('Error al listar los administradores', null, 'error', '2000');

      this.message = null;
      this.submitted = true;
      this.$validator.validate().then(valid => {

        if (valid == true) {

          this.loading = true;

          login(this.email, this.password).then(response => {

            if (response.status == 'success' && response.data.access_token) {

              if (response.data.user.banned) {
                this.message = `Acceso bloquedo. Ponte en contanto con la organización ${MIMOTO_MAIL_CLIENTS.label}`
                this.loading = false;
                return;
              }

              localStorage.setItem('invitation_token', response.data.user.invitation_token);
              this.$router.push({ path: '/' })
            } else {
              this.loading = false;
              if (response.data.message == "Unauthorized") {
                this.message = "Usuario o contraseña incorrectos."
              } else {
                this.message = "Se ha producido un error al iniciar sesión. Inténtalo de nuevo en unos minutos."
              }
            }

          }).catch(error => {
            this.loading = false;
            if (error && error.status == 401) {
              this.message = "Usuario o contraseña incorrectos."
            } else if (error && (error.status == 404 || error.status == 403) && error.data && error.data.message) {
              this.message = error.data.message;
            } else {
              this.message = "Se ha producido un error al iniciar sesión. Inténtalo de nuevo en unos minutos."
            }
            // this.$refs.toast.showToast('Error', null, 'error', '2000');
          });


        }
      });
    }
  }
}


</script>

<style lang="scss" scoped>
@import '~@/assets/scss/mimoto.scss';

.app {
  width: 100%;
  background-image: url("~@/assets/img/login-background.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left top;
  // margin-top: $header;
  position: relative;

  @media (min-width: 768px) {
    min-height: 100vh;
  }

  & > * {
    z-index: 2;
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(#a8d7e7, 0.5);//#f3f6f9; #A6C4CE  2d5b83
    width: 100%;
    height: 100%;
    z-index: 1;
    opacity: 0.9;
  }

  .register-title {
    font-family: $varela;
  }

}

  .invalid-feedback {
      // display: none;
      // width: 100%;
      margin-top: 0.4rem !important;
      // font-size: 80%;
      // color: #e55353;
  }

  .login {

    // width: 100%;
    // min-height: 100vh;
    // background-image: url("../../../../assets/img/login-background.jpg");//url("./src/assets/img/login-background.jpg");
    // background-size: cover;
    // background-repeat: no-repeat;
    // background-position: center;//left top;
    // // margin-top: $header;
    // // background-attachment: fixed;
    // position: relative;

    @media(max-width: 400px) {

      img {
        height:60px !important;

        display: flex;
        align-items: center;
        justify-content: center;

      }
    }

  }

  .new-account {
    color: $Blue;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }


</style>

